export default __webpack_public_path__ + "static/7_Screenshot-b9338f1c43cbf2a629a27abe77d68cbd.png";